/* global performance, _, angular, EventSource */
(function () {
  'use strict';

  var id = 'activity';

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/activity/:cardId/top', {
      templateUrl: 'modules/app/activity/activity-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/activity/:cardId/:groupId?', {
      templateUrl: 'modules/app/activity/detail/activity-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    //Register card icon preferences
    CardIconMap.register({
      "activity": "activity"
    });
  }]).
  // Difficulty measure thresholds
  constant("ActivityDifficultyThresholds", {
    discrimination: {
      good: 15.0,
      poor: 3.0
    },
    facility: {
      easy: 75.0,
      hard: 50.0
    }
  }).controller(id + ".Card", ["$scope", "$window", "wsConfig", "CardRegistry", id + ".SummaryCharts", id + ".ActivityCardResource", id + ".Utils", "wsEventNames", "$routeParams", 'CardUtils', 'Analytics', 'ReportValidationService', function ($scope, $window, wsConfig, CardRegistry, SummaryCharts, ActivityCardResource, ActivityUtils, wsEvents, $routeParams, CardUtils, Analytics, ReportValidationService) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.wsConfig = wsConfig;
    $scope.helpLink = "https://watershedlrs.zendesk.com/hc?environment=" + $window.location.hostname;
    $scope.helpClicked = Analytics.helpLinkClicked;
    $scope.defaultSummary = "Details for specific training or performance activities";
    $scope.detailsUrl = $scope.card && CardUtils.getCardUrl($scope.card);
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var params = {
      params: {
        cardId: $scope.cardId
      }
    };
    if ($scope.cardToPreview) {
      if (_.size($scope.cardToPreview.configuration.filter.activityIds) === 0) {
        $scope.hasData = false;
        return;
      }
      params = {
        params: {
          config: {
            filter: $scope.cardToPreview.configuration.filter
          }
        }
      };
    }
    var csvData = ActivityUtils.prepareCsvExport($scope.config.filter);
    if (csvData.userIsAdmin && !$scope.cardToPreview) {
      $scope.extraActions = ($scope.extraActions || []).concat([{
        downloadData: csvData.csvDownloadUrl
      }]);
    }
    var startTime = performance.now();
    var activityResource = new ActivityCardResource($scope.cardToPreview);
    activityResource.card.get("", params).then(function (response) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, response);
      }
      var resultData = response.results[0].result.allAttempts,
        results = resultData.results;

      // If we have completions data, show that
      if (_.some(results, function (r) {
        return r.completed;
      })) {
        $scope.completionsChart = SummaryCharts.getTimeChart(resultData, "month", "Completions", "completed", $scope.config.surveyMode, $scope.config);

        // If we have success data, show that
      } else if (_.some(results, function (r) {
        return r.succeeded;
      }) && !$scope.config.surveyMode) {
        $scope.completionsChart = SummaryCharts.getTimeChart(resultData, "month", "Successes", "succeeded", null, $scope.config);

        // Otherwise, show participation if there's any chart data at all
      } else {
        var chart = SummaryCharts.getTimeChart(resultData, "month", "Interactions", "participated", null, $scope.config);
        if (chart.series.length > 0 && chart.series[0].data.length > 0) {
          $scope.completionsChart = chart;
        }
      }
    }, function error() {
      $scope.hasData = false;
    }).then(function () {
      activityResource.reportLoaded(Math.round(performance.now() - startTime));
    });
    $scope.dataCount = SummaryCharts.getActivityCount($scope.cardId, $scope.cardToPreview).then(function (count) {
      $scope.dataCount = count;
      $scope.hasData = count > 0;
    }, function error() {
      $scope.hasData = false;
    });

    //note: this count will be zero if not filtered by any activities
    var activityIds = $scope.cardToPreview ? $scope.cardToPreview.configuration.filter.activityIds : $scope.config.filter.activityIds;
    $scope.activityCount = activityIds && activityIds.ids ? activityIds.ids.length : 0;
  }]).controller(id + ".Detail", ["$scope", "CardQueryResource", "$routeParams", "CardRegistry", "CardUtils", '$uibModal', id + ".SummaryCharts", id + ".Groups", id + ".ActivityCardResource", id + ".Utils", id + ".Leaderboard", "GroupUtils", 'ActivityDifficultyThresholds', 'Utils', '$location', "UserRoles", "User", 'ReportValidationService', 'OrganizationSettings', 'Resource', 'ChartUtils', function ($scope, CardQueryResource, $routeParams, CardRegistry, CardUtils, $uibModal, SummaryCharts, Groups, ActivityCardResource, ActivityUtils, Leaderboard, GroupUtils, DifficultyThresholds, Utils, $location, UserRoles, User, ReportValidationService, OrganizationSettings, Resource, ChartUtils) {
    $scope.card = $scope.card ? $scope.card : CardRegistry.get($routeParams.cardId);
    $scope.cardId = $scope.cardId ? $scope.cardId : $routeParams.cardId;
    $scope.config = $scope.card.configuration;
    $scope.firstSections = [];
    var preview = $scope.cardId === "preview";
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var downloadStatementsURL = ActivityUtils.prepareCsvExport($scope.config.filter).csvDownloadUrl;
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      hide: $scope.cardId === 'preview',
      href: CardQueryResource.getDownloadUrl('activity/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: downloadStatementsURL
    }];

    // Needs to be defined in order to set meta-data on it.
    $scope.pagenote = {
      clearCacheAction: "cards/" + $scope.card.id + "/cache",
      windowReload: true
    };
    $scope.hasData = null;
    if (!$scope.isPartial) {
      CardUtils.setNavElements($scope, $scope.card.title, $scope.cardId);
    }
    $scope.loading = true;

    // Helper method because our top group chart needs a single legend to cover multiple charts
    // so we must create our own
    $scope.activityGroupChartColor = function (index) {
      var defaults = ['lightgray', 'rgb(38, 212, 255)', 'rgb(151, 199, 114)', 'rgb(230, 102, 101)'];
      return {
        "background-color": ChartUtils.getSeriesColor($scope.config, index, defaults[index])
      };
    };
    $scope.groupInfo = {};
    var filter = $scope.card.configuration.filter;
    GroupUtils.startGroups(createDetailsPage, $scope.groupInfo, filter);
    var sectionDefaults = {
      bullet: null,
      chart: null,
      customCharts: null,
      title: {
        text: null,
        emphasized: false
      },
      subtitle: null,
      currentDuration: "Month",
      updateChartData: null,
      durations: [],
      height: 400,
      width: undefined,
      questionId: null,
      isQuestion: false
    };
    $scope.changeSelectedGroup = function changeSelectedGroup(newGroup) {
      $location.url(GroupUtils.createGroupUrl($location.path()) + "/" + newGroup.id + ($location.search().shareKey ? '?shareKey=' + $location.search().shareKey : ''));
    };
    function describeSection(values) {
      var section = _.extend({}, sectionDefaults, values);
      if (_.isFunction(section.updateChartData)) {
        section.updateChartData();
      }
      return section;
    }
    function createDetailsPage(groups, noGroupFilter) {
      if (!(groups instanceof Array)) {
        groups = [];
      }
      var allChildrenIds = groups.reduce(function (acc, group) {
        return acc.concat(group.childGroupIds);
      }, []);
      // We use this parameter to help build the "all" group when using elasticsearch
      var groupIdsThatAreChildren = groups.map(function (g) {
        return g.id;
      }).filter(function (g) {
        return allChildrenIds.includes(g);
      });
      var reportParams = {
        cardId: $scope.cardId,
        groupIds: groups.map(function (g) {
          return g.id;
        }),
        childrenIds: groupIdsThatAreChildren,
        noGroupFilter: noGroupFilter
      };
      if (preview) {
        reportParams.config = $scope.card.configuration;
        reportParams.config.displaySection = {
          "sentence": false,
          "reports": true,
          "leaderboard": true,
          "groupTable": true,
          "scoreDistribution": true,
          "questions": true,
          "completions": true,
          "groupChart": true,
          "individualAnswers": true,
          "averageDuration": true,
          "averageScore": true
        };
      }

      //note: this count will be zero if not filtered by any activities
      var activityIds = $scope.card.configuration.filter.activityIds,
        activityCount = $scope.activityCount ? $scope.activityCount : activityIds && activityIds.ids ? activityIds.ids.length : 0;
      var activityResource = new ActivityCardResource(preview ? $scope.card : null),
        overviewUrl = $scope.overviewUrl ? $scope.overviewUrl : activityResource.overview.getUrl(),
        questionsUrl = $scope.questionsUrl ? $scope.questionsUrl : activityResource.questions.getUrl();
      var startTime = performance.now();
      var queryMethod = CardQueryResource.getWithProgress;
      var overviewPromise = queryMethod({
        path: overviewUrl,
        params: reportParams,
        progressChannel: $scope.cardId
      }).then(onSuccessfulCall, onFailedCall);
      var questionPromise = queryMethod({
        path: questionsUrl,
        params: reportParams,
        progressChannel: $scope.cardId
      }).then(onSuccessfulCall, onFailedCall);
      var reportMetadata = {};
      if ($scope.promises) {
        $scope.promises.reportPromise = Promise.all([overviewPromise, questionPromise]);
      }

      // Process overview response
      overviewPromise.then(function (overviewResponse) {
        $scope.overviewIsLoading = false;
        if (overviewResponse === null) {
          return;
        }

        // Update wsDetailPagenote with report metadata
        $scope.pagenote.setReportMetadata(Object.assign(reportMetadata, overviewResponse));
        var data = _.indexBy(overviewResponse.results, function (r) {
          return r.name;
        });
        var allReport = data.REPORT.result.allAttempts.results.all,
          isScaledScore = allReport.countWithScaledScore > 0,
          averageScore = Math.round(allReport.averageScore),
          hasDuration = allReport.countWithDuration > 0,
          averageDurationCentiseconds = allReport.averageDurationCentiseconds,
          activityDisplay = activityCount !== 1 ? "activities" : "activity",
          showScore = !$scope.config.surveyMode;
        var sentenceSection = describeSection({
          index: 0,
          sentence: true,
          completions: allReport.completed,
          activityType: activityDisplay,
          isScaledScore: isScaledScore,
          averageScore: averageScore,
          showScore: showScore,
          hasDuration: hasDuration,
          averageDurationCentiseconds: averageDurationCentiseconds,
          selectedGroupName: $scope.groupInfo.selectedGroupName,
          activityCount: activityCount
        });
        var reportGroups = {},
          groupChartSection = false,
          groupTableSection = false;
        if (!_.isEmpty(groups)) {
          reportGroups = _.clone(data.REPORT.result.allAttempts.results);
          var totalActors = reportGroups.all.userCount;
          delete reportGroups.all;
          var hasGroupData = false;
          angular.forEach(groups, function (group) {
            if (group.id in reportGroups) {
              reportGroups[group.id].name = group.name;
              reportGroups[group.id].id = group.id;
              reportGroups[group.id].group = group;
              if (reportGroups[group.id].userCount > 0) {
                hasGroupData = true;
              }
              if ($scope.groupInfo.selectedGroup && group.id === $scope.groupInfo.selectedGroup.id) {
                reportGroups[group.id].selected = true;
              }
            }
          });
          var groupCharts = Groups.getGroupCharts(reportGroups, groups, $scope.config.surveyMode, $scope.config);
          var allEmptyCharts = _.isEmpty(groupCharts) || _.reduce(groupCharts, function (memo, groupChart) {
            return groupChart.empty && memo;
          }, true);
          if (hasGroupData && !allEmptyCharts && $scope.groupInfo.showGroups) {
            var groupCompletionsSectionTitle = "Completions, Incompletes, Successes, and Failures";
            if ($scope.config.surveyMode === true) {
              groupCompletionsSectionTitle = "Completions and Incompletes";
            }
            groupChartSection = describeSection({
              index: 1,
              data: reportGroups,
              title: {
                text: $scope.groupInfo.companyName + groupCompletionsSectionTitle,
                emphasized: true,
                main: true
              },
              groupChart: true,
              updateChartData: function updateChartData() {
                this.chartData = Groups.getGroupCharts(this.data, groups, $scope.config.surveyMode, $scope.config);
              },
              height: 75,
              totalActors: totalActors,
              separate: $scope.groupInfo.selectedGroup ? groups.length > 1 : false,
              showLink: $scope.groupInfo.showGroupLink && !preview
            });
          }
          if (hasGroupData && $scope.groupInfo.showGroups) {
            angular.forEach(reportGroups, function (val) {
              val.completedPercent = val.completed / val.participated * 100;
              val.succeededPercent = val.succeeded / val.participated * 100;
            });
            groupTableSection = describeSection({
              index: 7,
              data: reportGroups,
              title: {
                text: $scope.groupInfo.selectedGroup ? "Members of " + $scope.groupInfo.companyName : "Members",
                emphasized: true,
                main: true
              },
              groupTable: true,
              selections: ["Total", "Percentage"],
              currentlySelected: "Total",
              separate: $scope.groupInfo.selectedGroup ? groups.length > 1 : false,
              showLink: $scope.groupInfo.showGroupLink && !preview
            });
          }
        }
        var completionsSection = false;
        if (_.some(data.RESULTS_BY_TIME.result.allAttempts.results, function (r) {
          return r.completed;
        })) {
          // Completions & Successes
          var completionsSectionTitle = "Completions & Successes";
          if ($scope.config.surveyMode === true) {
            completionsSectionTitle = "Completions";
          }
          completionsSection = describeSection({
            index: 5,
            completions: true,
            data: data.RESULTS_BY_TIME.result.allAttempts,
            durations: ["Day", "Week", "Month", "Year"],
            title: {
              text: $scope.groupInfo.companyName + completionsSectionTitle,
              emphasized: true,
              main: true
            },
            updateChartData: function updateChartData() {
              this.chart = SummaryCharts.getTimeChart(this.data, this.currentDuration, null, null, $scope.config.surveyMode, $scope.config);
              this.subtitle = SummaryCharts.getCompletionsSubtitle($scope.card.title, this.data);
            }
          });
        }
        var averageScoreSection = false;
        // Average Score
        if (_(data.RESULTS_BY_TIME.result.allAttempts.results).some(function (date) {
          return date.hasScores > 0;
        })) {
          averageScoreSection = describeSection({
            index: 4,
            isScoreChart: true,
            averageScore: true,
            currentScoreType: 'all',
            data: data.RESULTS_BY_TIME.result.allAttempts,
            durations: ["Day", "Week", "Month", "Year"],
            title: {
              text: $scope.groupInfo.companyName + "Average Score",
              emphasized: true,
              main: true
            },
            subtitle: "Use this graph to see how the average score of " + $scope.card.title + " changes over time.",
            updateChartData: function updateChartData() {
              var scoreTypeModifier = Utils.capitalize(this.currentScoreType);
              if (scoreTypeModifier === 'All') {
                scoreTypeModifier = '';
              }
              this.chart = SummaryCharts.getTimeChart(this.data, this.currentDuration, "Score", "average" + scoreTypeModifier + "Score", null, $scope.config);
            }
          });
        }
        var averageDurationSection = false;
        if (_(data.RESULTS_BY_TIME.result.allAttempts.results).some(function (date) {
          return date.countWithDuration > 0;
        })) {
          var label = "";
          if (groups && $scope.groupInfo.selectedGroup) {
            label = " for " + $scope.groupInfo.companyName;
          }

          // Average Duration
          averageDurationSection = describeSection({
            index: 6,
            averageDuration: true,
            data: data.RESULTS_BY_TIME.result.allAttempts,
            durations: ["Day", "Week", "Month", "Year"],
            title: {
              text: "Average Time to Complete" + label,
              emphasized: true,
              main: true
            },
            subtitle: "Use this graph to see how the average time spent in " + $scope.card.title + " changes over time.",
            updateChartData: function updateChartData() {
              this.chart = SummaryCharts.getTimeChart(this.data, this.currentDuration, "Minutes", "formattedDuration", null, $scope.config);
            }
          });
        }
        var scoreDistributionSection = initScoreDistributionSection(data.SCORE_DISTRIBUTION);

        // Hide personally identifiable information if user is a Consultant or report configured to hide PII
        $scope.hidePII = UserRoles.isConsultant(User.get()) || $scope.config.hidePII;

        // Leaderboard
        //Position 3
        var leaderboardSection = false;
        if (!$scope.hidePII && !_.isEmpty(data.LISTER.result.allAttempts.results)) {
          leaderboardSection = Leaderboard.createDefinition(data.LISTER.result, $scope.cardId, $scope.card);
        }
        $scope.firstSections = [sentenceSection, groupChartSection, leaderboardSection, scoreDistributionSection, averageScoreSection, completionsSection, averageDurationSection, groupTableSection].filter(Boolean);
        var sectionsToDisplay = _.clone($scope.config.displaySection);
        if ($scope.config.surveyMode === true) {
          sectionsToDisplay.scoreDistribution = false;
          sectionsToDisplay.averageScore = false;
        }
        removeHiddenSections();
        $scope.$emit('activity-loaded', {
          data: data
        });
        $scope.loading = false;
      }, function error() {
        $scope.hasData = false;
      }).then(function () {
        activityResource.reportLoaded(Math.round(performance.now() - startTime));
      });

      // Process questions response
      questionPromise.then(function (responses) {
        $scope.questionsAreLoading = false;
        if (responses === null) {
          return;
        }
        $scope.stripHTML = Utils.stripHTML;
        $scope.lastSections = [];
        var questionResponse = responses;

        // The download link will download all statements, so add the question counts
        reportMetadata.totalHits += questionResponse.totalHits;
        reportMetadata.processedHits += questionResponse.processedHits;
        reportMetadata.refreshStartedOn = questionResponse.refreshStartedOn;
        reportMetadata.durationMillis = questionResponse.durationMillis;

        // Update wsDetailPagenote with report metadata
        $scope.pagenote.setReportMetadata(reportMetadata);
        var data = _.indexBy(questionResponse.results, function (r) {
          return r.name;
        });
        var difficultyResultList = data.DIFFICULTY.result.allAttempts.results.questionResults,
          maxAverageTimeCentiseconds = _.max(data.ASSESSMENTS.result.allAttempts.results, function (d) {
            return d.averageDurationCentiseconds;
          }).averageDurationCentiseconds;
        if (data.ASSESSMENTS.result && data.ASSESSMENTS.result.allAttempts && data.ASSESSMENTS.result.allAttempts.results && data.ASSESSMENTS.result.allAttempts.results.length > 0) {
          var hideIndividualAnswers = false;
          if (typeof $scope.config.displaySection.individualAnswers !== 'undefined') {
            hideIndividualAnswers = !$scope.config.displaySection.individualAnswers;
          }
          $scope.lastSections.push({
            questions: {
              questionData: data.ASSESSMENTS.result,
              difficultyData: data.DIFFICULTY,
              createDataOptions: true,
              hideTitle: true,
              cardId: $scope.cardId,
              downloadUrl: function downloadUrl(questionId) {
                var f = angular.copy($scope.config.filter);
                f.activityIds = {
                  ids: [questionId]
                };
                delete f.activityTypes;
                return ActivityUtils.prepareCsvExport(f).csvDownloadUrl;
              },
              surveyMode: $scope.config.surveyMode,
              hideIndividualAnswers: hideIndividualAnswers,
              config: $scope.config
            }
          });
        }

        // Question Summaries
        var averageTimeCentiseconds = data.DIFFICULTY.result.allAttempts.results.averageTimeCentiseconds;
        function filterDifficulty(dataset, text, filterFunc, explanation) {
          var t = _.filter(dataset, filterFunc);
          var questions = "questions are ";
          if (t.length === 1) {
            questions = "question is ";
          }
          return {
            "questions": t,
            "title": questions + text,
            "explanation": explanation
          };
        }
        if (difficultyResultList.length > 0 && !$scope.config.surveyMode) {
          $scope.lastSections.push(describeSection({
            title: {
              text: "Question Analysis"
            },
            bullet: makeAnalysisBullet(averageTimeCentiseconds, maxAverageTimeCentiseconds),
            reports: [filterDifficulty(difficultyResultList, "good at predicting who will do well on this test", function (a) {
              return a.discrimination > DifficultyThresholds.discrimination.good;
            }, "Questions that are good predictors of success have a high correlation " + "between successfully answering the question and good test performance."), filterDifficulty(difficultyResultList, "poor at predicting who will do well on this test", function (a) {
              return a.discrimination < DifficultyThresholds.discrimination.poor;
            }, "Questions that are poor predictors of success have a low correlation " + "between successfully answering the question and good test performance."), filterDifficulty(difficultyResultList, "easy", function (a) {
              return a.facility > DifficultyThresholds.facility.easy;
            }, "Easy questions have a high rate of success across all learners."), filterDifficulty(difficultyResultList, "hard", function (a) {
              return a.facility < DifficultyThresholds.facility.hard;
            }, "Hard questions have a low rate of success across all learners.")]
          }));
        }
        removeHiddenSections();
        function makeAnalysisBullet(avgTime, maxAvgTime) {
          if (avgTime && maxAvgTime) {
            return {
              data: {
                // values expected to be in centiseconds
                max: maxAvgTime,
                value: avgTime
              }
            };
          } else {
            return null;
          }
        }
        $scope.loading = false;
      });
      function onFailedCall() {
        $scope.hasData = false;
        return null;
      }
      function onSuccessfulCall(result) {
        $scope.hasData = true;
        return result;
      }
    }

    /**
     * Build the initial SCORE_DISTRIBUTION section for the report detail view.
     * Includes some defaults for the state of each scoreType which may later be updated
     * separately to reflect loading / error states.
     *
     * @param SCORE_DISTRIBUTION Object - Object resembling { name: String, result: Object }
     * @returns Object|Null - Either the section object, or null
     */
    function initScoreDistributionSection(SCORE_DISTRIBUTION) {
      var allScoresArray = Utils._try(function () {
        return SCORE_DISTRIBUTION.result.allAttempts.results.allScores;
      }, []);
      var hasResults = allScoresArray.reduce(function (acc, curr) {
        return acc ? acc : !!curr.count;
      }, false);
      if (!hasResults) {
        return null;
      }
      var section = describeSection({
        index: 3,
        subtitle: "Percentage of registrations with the following scores.",
        isScoreChart: true,
        scoreDistribution: true,
        currentScoreType: 'all',
        data: SCORE_DISTRIBUTION.result.allAttempts,
        title: {
          text: $scope.groupInfo.companyName + "Scores",
          emphasized: true,
          main: true
        },
        updateChartData: function updateChartData() {
          if (!_.isEmpty(this.data.results)) {
            this.chart = SummaryCharts.getScoresChart(this.data, this.currentScoreType, $scope.config);
          }
        }
      });
      section.state = getStatesForScoreDistribution(section);
      return section;
    }
    function removeHiddenSections() {
      _.each($scope.config.displaySection, function (isDisplayed, sectionId) {
        if (!isDisplayed) {
          // If a section is set to NOT display remove it from the sections to be created.
          $scope.firstSections = _.reject($scope.firstSections, function (s) {
            return !!s[sectionId];
          });
          $scope.lastSections = _.reject($scope.lastSections, function (s) {
            return !!s[sectionId];
          });
        }
      });
    }

    /**
     * Calculate the states from the data based on whether or not results exist for a scoreType.
     * This function determines that the data exists and has RESULTS or it is currently LOADING
     *
     * @param data - Nested property expected to exist (best if passed in directly from initScoreDistributionSection)
     */
    function getStatesForScoreDistribution() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref.data;
      // Get the existing keys that contain data; or just return an empty array
      var existingKeys = Utils._try(function () {
        return Object.keys(data.results);
      }, []);
      return {
        'all': existingKeys.includes('allScores') ? 'RESULTS' : 'LOADING',
        'first': existingKeys.includes('firstScores') ? 'RESULTS' : 'LOADING',
        'last': existingKeys.includes('lastScores') ? 'RESULTS' : 'LOADING',
        'best': existingKeys.includes('bestScores') ? 'RESULTS' : 'LOADING'
      };
    }
    $scope.openAnswersModal = function (_questionId, _title) {
      $uibModal.open({
        controller: "AnswersModalCtrl",
        templateUrl: 'modules/app/views/answers-modal.html',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          questionId: function questionId() {
            return _questionId;
          },
          cardId: function cardId() {
            return $scope.cardId;
          },
          title: function title() {
            return _title;
          },
          downloadUrl: function downloadUrl() {
            return $scope.definition.downloadUrl(_questionId);
          }
        }
      });
    };
  }]).service(id + ".Utils", ['$rootScope', 'UserRoles', 'QueryES', 'User', 'Resource', 'Utils', 'ShareKeyHelper', function ($rootScope, UserRoles, QueryES, User, Resource, Utils, ShareKeyHelper) {
    return {
      fetchFromES: function fetchFromES(config) {
        return new Promise(function (resolve, reject) {
          var shareKey = ShareKeyHelper.getShareKey();
          if (shareKey) {
            if (config.params) {
              config.params.shareKey = shareKey;
            } else {
              config.params = {
                shareKey: shareKey
              };
            }
          }
          var url = Utils.appendParams(config.path, config.params);
          var source = new EventSource(url);
          source.addEventListener("results", function (evt) {
            resolve(JSON.parse(evt.data));
          });
          source.addEventListener("error", function (evt) {
            var message = "An unexpected error occurred and more information is unavailable at this time.";
            if (evt.data) {
              message = "Error: ".concat(JSON.parse(evt.data));
            }
            reject(message);
          });
          source.onerror = function () {
            if (source.readyState !== source.OPEN) {
              source.close();
            }
          };
        });
      },
      prepareCsvExport: function prepareCsvExport(filter) {
        //create url for admins to be able to download statements associated with this screen
        var downloadFilters = angular.copy(filter);
        if (filter.activityIds && filter.activityIds.ids) {
          var activityFilters = {
            or: [{
              activityIds: {
                ids: filter.activityIds.ids,
                regExp: filter.activityIds.regExp
              }
            }, {
              contextActivityIds: {
                ids: filter.activityIds.ids,
                regExp: filter.activityIds.regExp
              }
            }]
          };
          delete downloadFilters.activityIds;
          _.extend(downloadFilters, activityFilters);
        }
        return {
          userIsAdmin: UserRoles.isOrgAdmin(User.get()),
          csvDownloadUrl: QueryES.queryExportUrl({
            "filter": downloadFilters
          }, true, id)
        };
      }
    };
  }]);
})();
